import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useUpdateUserMutation } from "store/features/users/userManagementApi";
import hashPassword from "utils/hashPassword";

const EditProfileModal = ({ isOpen, toggle, user, onProfileUpdate }) => {
  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const [profileImage, setProfileImage] = useState(null);
  const [nidCard, setNidCard] = useState(null);

  const handleSubmit = async (data) => {
    try {
      const formData = new FormData();

      // Append user data
      formData.append('nickname', data.nickname);
      formData.append('personal_email', data.personal_email);
      formData.append('phone', data.phone || '');
      formData.append('emp_id', data.emp_id || '');
      formData.append('official_email', data.official_email || '');
      formData.append('date_of_birth', data.date_of_birth || '');
      formData.append('gender', data.gender || '');
      formData.append('address', data.address || '');
      formData.append('position', data.position || '');
      formData.append('experience_years', data.experience_years || '');
      formData.append('blood_group', data.blood_group || '');
      formData.append('joining_date', data.joining_date || '');
      formData.append('city', data.city || '');
      formData.append('alt_phone', data.alt_phone || '');
      formData.append('emergency_phone', data.emergency_phone || '');

      if (data.password && data.password.trim() !== "") {
        const hashedPassword = await hashPassword(data.password);
        formData.append("password_hash", hashedPassword);
      }

      // Append profile image if selected
      if (profileImage) {
        formData.append('image', profileImage);
      }
      if (nidCard) {
        formData.append('nid_card', nidCard);
      }

      await updateUser({ id: user.id, formData }).unwrap();

      onProfileUpdate();
    } catch (error) {
      console.error('Profile update error:', error);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setProfileImage(file);
  };

  const handleImageChangeTwo = (event) => {
    const file = event.target.files[0];
    setNidCard(file);
  };

  const getFileName = (file, existingFile) => {
    if (file) return file.name;
    if (existingFile) return "Current image (will keep existing)";
    return 'No file chosen';
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    return `https://qwikbistro.shop${imagePath}`;
  };

  const handleModalClose = () => {
    setProfileImage(null);
    setNidCard(null);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} size="lg">
      <ModalHeader toggle={handleModalClose}>Edit Profile</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={user}>
        <ModalBody>
          <Row>
            {/* Profile Image */}
            <Col lg={12} className="text-center mb-4">
              {user?.image && (
                <img
                  src={user.image}
                  alt={user.nickname}
                  className="rounded-circle mb-3"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover"
                  }}
                />
              )}
              <FormGroup>
                <Label for="profile_image" className="form-label">
                  Profile Image
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="profile_image"
                    accept=".jpg,.jpeg,.png,.gif"
                    onChange={handleImageChange}
                  />
                  {/* <label className="custom-file-label" htmlFor="profile_image">
                    {getFileName(profileImage, user?.image)}
                  </label> */}
                </div>
                {/* <small className="form-text text-muted">
                  {profileImage ? "New image will replace existing" : "Keep existing image if no new file selected"}
                </small> */}
              </FormGroup>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="nickname"
                  label="Name"
                  placeholder="Enter name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="personal_email"
                  label="Email"
                  placeholder="Enter email"
                  type="email"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="phone"
                  label="Phone Number"
                  placeholder="Enter phone number"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="password"
                  label="Password"
                  placeholder="Enter password"
                  type="password"
                  className="form-control"
                  required
                />
              </div>
            </Col>

            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="emp_id"
                  label="Employee ID"
                  placeholder="Enter employee ID"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col> */}
            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="official_email"
                  label="Official Email"
                  placeholder="Enter official email"
                  type="email"
                  className="form-control"
                />
              </div>
            </Col> */}
            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="date_of_birth"
                  label="Date of Birth"
                  type="date"
                  className="form-control"
                />
              </div>
            </Col> */}
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="position"
                  label="Position"
                  placeholder="Enter position"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="gender"
                  label="Gender"
                  options={[
                    { value: "male", label: "Male" },
                    { value: "female", label: "Female" },
                    { value: "other", label: "Other" }
                  ]}
                />
              </div>
            </Col>


            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="experience_years"
                  label="Experience (Years)"
                  placeholder="Enter years of experience"
                  type="number"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <Label for="nid_card" className="form-label">
                  Nid Card
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="nid_card"
                    accept=".jpg,.jpeg,.png,.gif"
                    onChange={handleImageChangeTwo}
                  />
                  {/* <label
                        className="custom-file-label"
                        htmlFor="profile_image"
                      >
                        {getFileName(profileImage)}
                      </label> */}
                </div>
                {/* <small className="form-text text-muted">
                      Upload profile image (JPG, PNG, GIF)
                    </small> */}
              </FormGroup>
            </Col>


            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="joining_date"
                  label="Joining Date"
                  type="date"
                  className="form-control"
                />
              </div>
            </Col> */}
            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="blood_group"
                  label="Blood Group"
                  options={[
                    { value: "A+", label: "A+" },
                    { value: "A-", label: "A-" },
                    { value: "B+", label: "B+" },
                    { value: "B-", label: "B-" },
                    { value: "AB+", label: "AB+" },
                    { value: "AB-", label: "AB-" },
                    { value: "O+", label: "O+" },
                    { value: "O-", label: "O-" }
                  ]}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="city"
                  label="City"
                  placeholder="Enter city"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="alt_phone"
                  label="Alternative Phone"
                  placeholder="Enter alternative phone"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col> */}
            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="emergency_phone"
                  label="Emergency Phone"
                  placeholder="Enter emergency phone"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col> */}

          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Profile"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditProfileModal;